<ng-container [ngSwitch]="icon">
  <svg
    *ngSwitchCase="menuIconTypes.MY_MEASURES"
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.9724 10.2381C16.9724 10.1832 16.1153 10.8411 15.8207 11.741H14.0842L12.8164 7.83972C12.7181 7.53822 12.4458 7.33721 12.1378 7.33721H12.1244C11.8119 7.34178 11.5396 7.55649 11.4548 7.86713L9.4683 14.9617L7.13359 0.612722C7.08002 0.270102 6.79432 0.014279 6.45505 0.000574206C6.11578 -0.0131306 5.81669 0.219851 5.73187 0.553335L3.36591 11.741H0.714252C0.321413 11.741 0 12.0699 0 12.4719C0 12.874 0.321413 13.2029 0.714252 13.2029H3.92838C4.25426 13.2029 4.54443 12.9745 4.62032 12.6501L6.28988 4.32672L8.57995 18.3924C8.63352 18.7305 8.91029 18.9817 9.2451 19H9.28527C9.60222 19 9.88346 18.7853 9.97274 18.4701L12.1914 10.5396L12.8922 12.7004C12.9905 12.9973 13.2628 13.2029 13.5708 13.2029H15.8519C16.1599 14.0252 16.9412 14.619 17.8563 14.619C19.0616 14.619 20.0348 13.6003 19.999 12.3577C19.9633 11.2248 19.075 10.2975 17.9724 10.2381Z"
      [attr.fill]="color"
    />
  </svg>

  <svg
    width="20"
    *ngSwitchCase="menuIconTypes.EVENTS"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.0769 1.5H16.1538V2.625C16.1538 2.83125 15.9808 3 15.7692 3H15C14.7885 3 14.6154 2.83125 14.6154 2.625V1.5H5.38462V2.625C5.38462 2.83125 5.21154 3 5 3H4.23077C4.01923 3 3.84615 2.83125 3.84615 2.625V1.5H1.92308C0.865385 1.5 0 2.34375 0 3.375V16.125C0 17.1562 0.865385 18 1.92308 18H18.0769C19.1346 18 20 17.1562 20 16.125V3.375C20 2.34375 19.1346 1.5 18.0769 1.5ZM18.4615 15.5625C18.4615 16.0781 18.0288 16.5 17.5 16.5H2.5C1.97115 16.5 1.53846 16.0781 1.53846 15.5625V7.125C1.53846 6.91875 1.71154 6.75 1.92308 6.75H18.0769C18.2885 6.75 18.4615 6.91875 18.4615 7.125V15.5625ZM5.38462 0.375C5.38462 0.16875 5.21154 0 5 0H4.23077C4.01923 0 3.84615 0.16875 3.84615 0.375V1.5H5.38462V0.375ZM16.1538 0.375C16.1538 0.16875 15.9808 0 15.7692 0H15C14.7885 0 14.6154 0.16875 14.6154 0.375V1.5H16.1538V0.375Z"
      [attr.fill]="color"
    />
  </svg>

  <svg
    *ngSwitchCase="menuIconTypes.MESSAGES"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.4,16.7V7H1.8C0.8,7,0,7.8,0,8.8V25l3.5-3.4h12.7c1,0,1.8-0.8,1.8-1.8v-0.4H5C3.8,19.3,2.4,17.9,2.4,16.7z"
      [attr.fill]="color"
    />
    <path
      d="M22.9,0H6.1C4.9,0,4,0.9,4,2.1v13.6c0,1.2,0.9,2.1,2.1,2.1h14.3L25,21V2.1C25,0.9,24.1,0,22.9,0z"
      [attr.fill]="color"
    />
  </svg>

  <svg
    *ngSwitchCase="menuIconTypes.HOME"
    width="23"
    height="26"
    viewBox="0 0 23 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.7214 0.337456C11.5463 0.16086 11.3043 0.0614156 11.0538 0.0628507C10.8034 0.0637964 10.5626 0.165479 10.3895 0.343286L0.320517 10.686C0.154809 10.8562 0.0627834 11.0827 0.0641348 11.3185L0.139023 24.3874C0.14039 24.6261 0.240597 24.8596 0.413427 25.0273C0.586777 25.1955 0.825393 25.2912 1.06912 25.2898L21.2424 25.1742C21.4855 25.1728 21.7228 25.0744 21.8942 24.9042C22.0657 24.734 22.1632 24.4999 22.1618 24.2612L22.0868 11.167C22.0854 10.9317 21.992 10.708 21.8248 10.5397L11.7214 0.337456ZM14.2089 19.5306L8.03743 19.566L8.00271 13.5079L14.1742 13.4725L14.2089 19.5306Z"
      [attr.fill]="color"
    />
  </svg>

  <svg
    *ngSwitchCase="menuIconTypes.MEASURES"
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 0C5.14736 0 0 5.14736 0 11.5C0 17.8526 5.14736 23 11.5 23C17.8526 23 23 17.8526 23 11.5C23 5.14736 17.8526 0 11.5 0ZM16.5036 12.3846H12.3846V16.5036C12.3846 16.9901 11.9865 17.3882 11.5 17.3882C11.2567 17.3882 11.0356 17.2887 10.8752 17.1284C10.7149 16.968 10.6154 16.7469 10.6154 16.5036V12.3846H6.49639C6.25312 12.3846 6.03197 12.2851 5.87163 12.1248C5.7113 11.9644 5.61178 11.7433 5.61178 11.5C5.61178 11.0135 6.00986 10.6154 6.49639 10.6154H10.6154V6.49639C10.6154 6.00986 11.0135 5.61178 11.5 5.61178C11.9865 5.61178 12.3846 6.00986 12.3846 6.49639V10.6154H16.5036C16.9901 10.6154 17.3882 11.0135 17.3882 11.5C17.3882 11.9865 16.9901 12.3846 16.5036 12.3846Z"
      [attr.fill]="color"
    />
  </svg>

  <svg
    *ngSwitchCase="menuIconTypes.LOGOUT"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.4792 2.4844C16.3073 2.33856 16.0885 2.26044 15.8646 2.26044C15.5885 2.26044 15.3229 2.38023 15.1458 2.59377C14.9792 2.78648 14.901 3.03127 14.9219 3.28648C14.9427 3.53648 15.0625 3.77085 15.2552 3.93231C17.0677 5.46877 18.1094 7.69794 18.1094 10.0469C18.1094 14.4948 14.474 18.1094 10.0052 18.1094C5.53646 18.1094 1.90104 14.4896 1.90104 10.0469C1.90104 7.69273 2.94271 5.46356 4.75521 3.93231C4.94792 3.77085 5.06771 3.54169 5.08854 3.28648C5.10937 3.03648 5.03125 2.78648 4.86458 2.59377C4.68229 2.38544 4.42188 2.26044 4.14583 2.26044C3.92188 2.26044 3.70312 2.33856 3.53125 2.4844C1.28646 4.38023 0 7.13544 0 10.0417C0 15.5313 4.48438 20 10 20C15.5156 20 20 15.5313 20 10.0417C20 7.13544 18.7135 4.38023 16.4792 2.4844Z"
      [attr.fill]="color"
    />
    <path
      d="M10.0469 10.9635C10.5781 10.9635 11.0104 10.5313 11.0104 10V0.963542C11.0104 0.432292 10.5781 0 10.0469 0C9.5156 0 9.08331 0.432292 9.08331 0.963542V10C9.08331 10.5313 9.5156 10.9635 10.0469 10.9635Z"
      [attr.fill]="color"
    />
  </svg>

  <svg
    *ngSwitchCase="menuIconTypes.HELP"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 20C4.47596 20 0 15.524 0 10C0 4.47596 4.47596 0 10 0C15.524 0 20 4.47596 20 10C20 15.524 15.524 20 10 20ZM12.9327 2.88461L12.3462 4.78846C12.9712 5.06731 13.5433 5.46154 14.0433 5.96154C14.5433 6.46154 14.9375 7.03365 15.2163 7.65865L17.1154 7.07692C16.7356 6.14904 16.1683 5.29808 15.4375 4.56731C14.7115 3.83173 13.8606 3.26442 12.9327 2.88461ZM7.06731 17.1154L7.65385 15.2115C7.02885 14.9327 6.45673 14.5385 5.95673 14.0385C5.45673 13.5385 5.0625 12.9663 4.78365 12.3413L2.88462 12.9231C3.26442 13.851 3.83173 14.7019 4.5625 15.4327C5.28846 16.1683 6.13942 16.7356 7.06731 17.1154ZM10 13.0769C11.6971 13.0769 13.0769 11.6971 13.0769 10C13.0769 8.30288 11.6971 6.92308 10 6.92308C8.30289 6.92308 6.92308 8.30288 6.92308 10C6.92308 11.6971 8.30289 13.0769 10 13.0769ZM15.4375 15.4375C16.1683 14.7067 16.7308 13.8558 17.1154 12.9327L15.2163 12.3462C14.9327 12.9712 14.5433 13.5433 14.0433 14.0433C13.5433 14.5433 12.9712 14.9375 12.3462 15.2163L12.9279 17.1154C13.8558 16.7356 14.7067 16.1683 15.4375 15.4375ZM4.5625 4.5625C3.83173 5.28846 3.26442 6.13942 2.88462 7.06731L4.78365 7.65385C5.06731 7.02885 5.45673 6.45673 5.95673 5.95673C6.45673 5.45673 7.02885 5.0625 7.65385 4.78365L7.07212 2.88461C6.14423 3.26442 5.29327 3.83173 4.5625 4.5625Z"
      [attr.fill]="color"
    />
  </svg>

  <svg
    *ngSwitchCase="menuIconTypes.PROFILE"
    width="20"
    height="24"
    viewBox="0 0 20 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="content"
      d="M10 11.6208C13.224 11.6208 15.8333 9.02168 15.8333 5.8104C15.8333 2.59912 13.224 0 10 0C6.77604 0 4.16667 2.59912 4.16667 5.8104C4.16667 9.02168 6.77604 11.6208 10 11.6208ZM14 13.2809H13.5677C12.4844 13.7997 11.2812 14.111 10 14.111C8.71875 14.111 7.52083 13.7997 6.43229 13.2809H6C2.6875 13.2809 0 15.9578 0 19.2573V20.7514C0 22.1262 1.11979 23.2416 2.5 23.2416H17.5C18.8802 23.2416 20 22.1262 20 20.7514V19.2573C20 15.9578 17.3125 13.2809 14 13.2809Z"
      [attr.fill]="color"
    />
  </svg>

  <svg
    *ngSwitchCase="menuIconTypes.EDOCUMENTS"
    width="22"
    height="22"
    viewBox="0 0 71 85"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.9609 51.8238H36.6915V55.3862H18.9609V51.8238ZM53.0281 44.0809H18.9609V40.5184H53.0281V44.0809ZM53.0281 32.7755H18.9609V29.2131H53.0281V32.7755ZM53.0281 21.4701H18.9609V17.9077H53.0281V21.4701ZM55.7052 73.8366L48.4507 78.3801V55.4641H63.0018L62.9596 78.3801L55.7052 73.8366ZM44.7108 63.9519H9.23123C8.50328 63.9519 7.91248 63.3879 7.91248 62.6958V8.79306C7.91248 8.09966 8.50328 7.53691 9.23123 7.53691H61.7688C62.4954 7.53691 63.0875 8.09966 63.0875 8.79306L63.0084 51.7459H44.7108V51.8238V63.9519ZM35.978 77.3174C34.2465 77.3174 32.8434 75.9808 32.8434 74.3315C32.8434 72.6834 34.2465 71.3456 35.978 71.3456C37.7096 71.3456 39.1127 72.6834 39.1127 74.3315C39.1127 75.9808 37.7096 77.3174 35.978 77.3174ZM61.7688 0H9.23123C4.14086 0 0 3.94432 0 8.79306V76.2069C0 81.0544 4.14086 85 9.23123 85H61.7688C66.8578 85 71 81.0544 71 76.2069V8.79306C71 3.94432 66.8578 0 61.7688 0Z"
      [attr.fill]="color"
    />
  </svg>

  <ion-icon
    *ngSwitchCase="menuIconTypes.EDIARY"
    name="calendar-outline"
    [ngStyle]="{ 'font-size': '22px', color: color }"
  ></ion-icon>

  <!-- <svg
    width="207"
    height="237"
    viewBox="0 0 207 237"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27 31C12.0883 31 0 43.0883 0 58V210C0 224.912 12.0883 237 27 237H180C194.912 237 207 224.912 207 210V58C207 43.0883 194.912 31 180 31H27ZM190 64H15V208C15 213.523 19.4772 218 25 218H180C185.523 218 190 213.523 190 208V64Z"
      [attr.fill]="color"
    />
    <rect x="30" y="94" width="28" height="26" [attr.fill]="color"/>
    <rect x="70" y="94" width="28" height="26" [attr.fill]="color" />
    <rect x="110" y="94" width="28" height="26" [attr.fill]="color" />
    <rect x="150" y="94" width="28" height="26" [attr.fill]="color" />
    <rect x="30" y="129" width="28" height="26" [attr.fill]="color" />
    <rect x="70" y="129" width="28" height="26" [attr.fill]="color" />
    <rect x="110" y="129" width="28" height="26" [attr.fill]="color"/>
    <rect x="150" y="129" width="28" height="26" [attr.fill]="color" />
    <rect x="30" y="164" width="28" height="26" [attr.fill]="color" />
    <rect x="70" y="164" width="28" height="26" [attr.fill]="color"/>
    <rect x="110" y="164" width="28" height="26" [attr.fill]="color" />
    <rect x="150" y="164" width="28" height="26" [attr.fill]="color" />
    <path
      d="M66.5 17V45C66.5 51.9036 60.9036 57.5 54 57.5C47.0964 57.5 41.5 51.9036 41.5 45V17C41.5 10.0964 47.0964 4.5 54 4.5C60.9036 4.5 66.5 10.0964 66.5 17ZM116.5 17V45C116.5 51.9036 110.904 57.5 104 57.5C97.0964 57.5 91.5 51.9036 91.5 45V17C91.5 10.0964 97.0964 4.5 104 4.5C110.904 4.5 116.5 10.0964 116.5 17ZM166.5 17V45C166.5 51.9036 160.904 57.5 154 57.5C147.096 57.5 141.5 51.9036 141.5 45V17C141.5 10.0964 147.096 4.5 154 4.5C160.904 4.5 166.5 10.0964 166.5 17Z"
      fill="white"
      [attr.fill]="color"
      stroke-width="9"
    />
  </svg> -->

  <svg
    *ngSwitchDefault
    width="20"
    height="11"
    viewBox="0 0 20 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect class="content" width="20" height="11" rx="5.2" [attr.fill]="color" />
  </svg>
</ng-container>
